// extracted by mini-css-extract-plugin
module.exports = {"form":"ClgLd","fields-container":"_9gtsm","terms":"IKiVJ"};